import resolver, {ResolverSettings} from './utils/resolver';
import {Housing} from '../utils/types';

class HousingApi {
  ENDPOINTS = {
    getOne: (id = '') => `housings/${id}/`,
  };

  getOne(id: string, resolverSettings?: ResolverSettings) {
    return resolver<Housing>(
      this.ENDPOINTS.getOne(id),
      {method: 'GET'},
      {version: 'v4', ...resolverSettings},
    );
  }
}

export {HousingApi};
